<template>
  <div v-if="testId" v-set-test-id="['ThePageTitle', testId]" class="d-none" />
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import { vSetTestId } from '@/common/components/ActionableComponent';

type Props = ActionableComponentProps & { title: string };
const props = defineProps<Props>();

const { t } = useI18n();

watch(
  () => props.title,
  () => {
    document.title = [t('appTitle'), props.title]
      .filter(v => v && v.length > 0)
      .join(' / ');
  },
  { immediate: true },
);
</script>
